export default {
    'uicon-level': '\ue693',
    'uicon-column-line': '\ue68e',
    'uicon-checkbox-mark': '\ue807',
    'uicon-folder': '\ue7f5',
    'uicon-movie': '\ue7f6',
    'uicon-star-fill': '\ue669',
    'uicon-star': '\ue65f',
    'uicon-phone-fill': '\ue64f',
    'uicon-phone': '\ue622',
    'uicon-apple-fill': '\ue881',
    'uicon-chrome-circle-fill': '\ue885',
    'uicon-backspace': '\ue67b',
    'uicon-attach': '\ue632',
    'uicon-cut': '\ue948',
    'uicon-empty-car': '\ue602',
    'uicon-empty-coupon': '\ue682',
    'uicon-empty-address': '\ue646',
    'uicon-empty-favor': '\ue67c',
    'uicon-empty-permission': '\ue686',
    'uicon-empty-news': '\ue687',
    'uicon-empty-search': '\ue664',
    'uicon-github-circle-fill': '\ue887',
    'uicon-rmb': '\ue608',
    'uicon-person-delete-fill': '\ue66a',
    'uicon-reload': '\ue788',
    'uicon-order': '\ue68f',
    'uicon-server-man': '\ue6bc',
    'uicon-search': '\ue62a',
    'uicon-fingerprint': '\ue955',
    'uicon-more-dot-fill': '\ue630',
    'uicon-scan': '\ue662',
    'uicon-share-square': '\ue60b',
    'uicon-map': '\ue61d',
    'uicon-map-fill': '\ue64e',
    'uicon-tags': '\ue629',
    'uicon-tags-fill': '\ue651',
    'uicon-bookmark-fill': '\ue63b',
    'uicon-bookmark': '\ue60a',
    'uicon-eye': '\ue613',
    'uicon-eye-fill': '\ue641',
    'uicon-mic': '\ue64a',
    'uicon-mic-off': '\ue649',
    'uicon-calendar': '\ue66e',
    'uicon-calendar-fill': '\ue634',
    'uicon-trash': '\ue623',
    'uicon-trash-fill': '\ue658',
    'uicon-play-left': '\ue66d',
    'uicon-play-right': '\ue610',
    'uicon-minus': '\ue618',
    'uicon-plus': '\ue62d',
    'uicon-info': '\ue653',
    'uicon-info-circle': '\ue7d2',
    'uicon-info-circle-fill': '\ue64b',
    'uicon-question': '\ue715',
    'uicon-error': '\ue6d3',
    'uicon-close': '\ue685',
    'uicon-checkmark': '\ue6a8',
    'uicon-android-circle-fill': '\ue67e',
    'uicon-android-fill': '\ue67d',
    'uicon-ie': '\ue87b',
    'uicon-IE-circle-fill': '\ue889',
    'uicon-google': '\ue87a',
    'uicon-google-circle-fill': '\ue88a',
    'uicon-setting-fill': '\ue872',
    'uicon-setting': '\ue61f',
    'uicon-minus-square-fill': '\ue855',
    'uicon-plus-square-fill': '\ue856',
    'uicon-heart': '\ue7df',
    'uicon-heart-fill': '\ue851',
    'uicon-camera': '\ue7d7',
    'uicon-camera-fill': '\ue870',
    'uicon-more-circle': '\ue63e',
    'uicon-more-circle-fill': '\ue645',
    'uicon-chat': '\ue620',
    'uicon-chat-fill': '\ue61e',
    'uicon-bag-fill': '\ue617',
    'uicon-bag': '\ue619',
    'uicon-error-circle-fill': '\ue62c',
    'uicon-error-circle': '\ue624',
    'uicon-close-circle': '\ue63f',
    'uicon-close-circle-fill': '\ue637',
    'uicon-checkmark-circle': '\ue63d',
    'uicon-checkmark-circle-fill': '\ue635',
    'uicon-question-circle-fill': '\ue666',
    'uicon-question-circle': '\ue625',
    'uicon-share': '\ue631',
    'uicon-share-fill': '\ue65e',
    'uicon-shopping-cart': '\ue621',
    'uicon-shopping-cart-fill': '\ue65d',
    'uicon-bell': '\ue609',
    'uicon-bell-fill': '\ue640',
    'uicon-list': '\ue650',
    'uicon-list-dot': '\ue616',
    'uicon-zhihu': '\ue6ba',
    'uicon-zhihu-circle-fill': '\ue709',
    'uicon-zhifubao': '\ue6b9',
    'uicon-zhifubao-circle-fill': '\ue6b8',
    'uicon-weixin-circle-fill': '\ue6b1',
    'uicon-weixin-fill': '\ue6b2',
    'uicon-twitter-circle-fill': '\ue6ab',
    'uicon-twitter': '\ue6aa',
    'uicon-taobao-circle-fill': '\ue6a7',
    'uicon-taobao': '\ue6a6',
    'uicon-weibo-circle-fill': '\ue6a5',
    'uicon-weibo': '\ue6a4',
    'uicon-qq-fill': '\ue6a1',
    'uicon-qq-circle-fill': '\ue6a0',
    'uicon-moments-circel-fill': '\ue69a',
    'uicon-moments': '\ue69b',
    'uicon-qzone': '\ue695',
    'uicon-qzone-circle-fill': '\ue696',
    'uicon-baidu-circle-fill': '\ue680',
    'uicon-baidu': '\ue681',
    'uicon-facebook-circle-fill': '\ue68a',
    'uicon-facebook': '\ue689',
    'uicon-car': '\ue60c',
    'uicon-car-fill': '\ue636',
    'uicon-warning-fill': '\ue64d',
    'uicon-warning': '\ue694',
    'uicon-clock-fill': '\ue638',
    'uicon-clock': '\ue60f',
    'uicon-edit-pen': '\ue612',
    'uicon-edit-pen-fill': '\ue66b',
    'uicon-email': '\ue611',
    'uicon-email-fill': '\ue642',
    'uicon-minus-circle': '\ue61b',
    'uicon-minus-circle-fill': '\ue652',
    'uicon-plus-circle': '\ue62e',
    'uicon-plus-circle-fill': '\ue661',
    'uicon-file-text': '\ue663',
    'uicon-file-text-fill': '\ue665',
    'uicon-pushpin': '\ue7e3',
    'uicon-pushpin-fill': '\ue86e',
    'uicon-grid': '\ue673',
    'uicon-grid-fill': '\ue678',
    'uicon-play-circle': '\ue647',
    'uicon-play-circle-fill': '\ue655',
    'uicon-pause-circle-fill': '\ue654',
    'uicon-pause': '\ue8fa',
    'uicon-pause-circle': '\ue643',
    'uicon-eye-off': '\ue648',
    'uicon-eye-off-outline': '\ue62b',
    'uicon-gift-fill': '\ue65c',
    'uicon-gift': '\ue65b',
    'uicon-rmb-circle-fill': '\ue657',
    'uicon-rmb-circle': '\ue677',
    'uicon-kefu-ermai': '\ue656',
    'uicon-server-fill': '\ue751',
    'uicon-coupon-fill': '\ue8c4',
    'uicon-coupon': '\ue8ae',
    'uicon-integral': '\ue704',
    'uicon-integral-fill': '\ue703',
    'uicon-home-fill': '\ue964',
    'uicon-home': '\ue965',
    'uicon-hourglass-half-fill': '\ue966',
    'uicon-hourglass': '\ue967',
    'uicon-account': '\ue628',
    'uicon-plus-people-fill': '\ue626',
    'uicon-minus-people-fill': '\ue615',
    'uicon-account-fill': '\ue614',
    'uicon-thumb-down-fill': '\ue726',
    'uicon-thumb-down': '\ue727',
    'uicon-thumb-up': '\ue733',
    'uicon-thumb-up-fill': '\ue72f',
    'uicon-lock-fill': '\ue979',
    'uicon-lock-open': '\ue973',
    'uicon-lock-opened-fill': '\ue974',
    'uicon-lock': '\ue97a',
    'uicon-red-packet-fill': '\ue690',
    'uicon-photo-fill': '\ue98b',
    'uicon-photo': '\ue98d',
    'uicon-volume-off-fill': '\ue659',
    'uicon-volume-off': '\ue644',
    'uicon-volume-fill': '\ue670',
    'uicon-volume': '\ue633',
    'uicon-red-packet': '\ue691',
    'uicon-download': '\ue63c',
    'uicon-arrow-up-fill': '\ue6b0',
    'uicon-arrow-down-fill': '\ue600',
    'uicon-play-left-fill': '\ue675',
    'uicon-play-right-fill': '\ue676',
    'uicon-rewind-left-fill': '\ue679',
    'uicon-rewind-right-fill': '\ue67a',
    'uicon-arrow-downward': '\ue604',
    'uicon-arrow-leftward': '\ue601',
    'uicon-arrow-rightward': '\ue603',
    'uicon-arrow-upward': '\ue607',
    'uicon-arrow-down': '\ue60d',
    'uicon-arrow-right': '\ue605',
    'uicon-arrow-left': '\ue60e',
    'uicon-arrow-up': '\ue606',
    'uicon-skip-back-left': '\ue674',
    'uicon-skip-forward-right': '\ue672',
    'uicon-rewind-right': '\ue66f',
    'uicon-rewind-left': '\ue671',
    'uicon-arrow-right-double': '\ue68d',
    'uicon-arrow-left-double': '\ue68c',
    'uicon-wifi-off': '\ue668',
    'uicon-wifi': '\ue667',
    'uicon-empty-data': '\ue62f',
    'uicon-empty-history': '\ue684',
    'uicon-empty-list': '\ue68b',
    'uicon-empty-page': '\ue627',
    'uicon-empty-order': '\ue639',
    'uicon-man': '\ue697',
    'uicon-woman': '\ue69c',
    'uicon-man-add': '\ue61c',
    'uicon-man-add-fill': '\ue64c',
    'uicon-man-delete': '\ue61a',
    'uicon-man-delete-fill': '\ue66a',
    'uicon-zh': '\ue70a',
    'uicon-en': '\ue692'
}
